export default __webpack_public_path__ + "static/media/netflix-avatar.59623adb.png";